import CardHeader from '@mui/material/CardHeader';
import { styled } from '@mui/material/styles';

export default styled(CardHeader)(({ theme }) => ({
  boxShadow: `inset 0px -1px 0px ${theme.colors.strokeLight}`,
  '& .MuiCardHeader-title': {
    fontSize: '1.1428571428571428rem',
  },
}));
